import { useEffect } from 'react'

const GSIOrderHandler = () => {
  // Get the search params from the URL
  const searchParams = new URLSearchParams(window.location.search)

  // Extract the required parameters
  const newURL = new URL(`/external-order-handler`, window.location.origin)
  const sessionID = searchParams.get('SessionID') || ''
  const action = searchParams.get('Action') || ''

  useEffect(() => {
    // Redirect to external-order-handler route with the extracted parameters in new tab
    if (action === 'stock-order') {
      newURL.searchParams.append('OrderSuggestionUUID', searchParams.get('OrderSuggestionUUID') || '')
      newURL.searchParams.append('OrderAccountUUID', searchParams.get('OrderAccountUUID') || '')
    } else {
      newURL.searchParams.append('WorkorderUUID', searchParams.get('WorkorderUUID') || '')
      newURL.searchParams.append('WorkorderLineUUID', searchParams.get('WorkorderLineUUID') || '')
      newURL.searchParams.append('OrderAccountUUID', searchParams.get('OrderAccountUUID') || '')
    }

    newURL.searchParams.append('SessionID', sessionID)
    newURL.searchParams.append('Action', action)

    window.open(newURL, '_blank')
  }, [])

  return null
}

export default GSIOrderHandler
